// Primeiro import do bundle, de proposito (ver src/main.tsx). Assim, erros
// de carregamento dos proprios modulos da aplicacao ja sao capturados.
import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,

    integrations: [
      // Mede carregamento de pagina e navegacao entre rotas, e registra
      // cada chamada de fetch/xhr como breadcrumb - e assim que se ve o
      // que o usuario fez ANTES do erro.
      Sentry.browserTracingIntegration(),
    ],

    // Fracao das navegacoes/transacoes com trace de performance. Erros vao
    // sempre 100% independente deste valor.
    tracesSampleRate: 0.1,

    // Nao envia IP nem dados de formulario automaticamente. O usuario e
    // anexado explicitamente depois do login (ver hooks/useSentryUser.ts).
    sendDefaultPii: false,

    // tracePropagationTargets deixado de fora de proposito: a API roda em
    // dominio diferente (api.vidinhas.com) e ligar os headers sentry-trace/
    // baggage exigiria liberar CORS extra la. Sem isso o SDK so anexa esses
    // headers a requisicoes de mesma origem - o trace do front nao se conecta
    // ao do backend, mas nenhum CORS novo precisa ser aberto.

    // Ruido que nao e bug da aplicacao.
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
      "Non-Error promise rejection captured",
    ],
    denyUrls: [/extensions\//i, /^chrome:\/\//i, /^moz-extension:\/\//i],
  });

  console.log(`[sentry] ativo — environment=${import.meta.env.MODE}`);
} else {
  console.log("[sentry] VITE_SENTRY_DSN nao definida — monitoramento desativado");
}
